import { countryRoutes } from './countries';
import { currencyRoutes } from './currencies';
import { budgetGoalsRoutes } from './budget-goals';

export const generalRoutes = [
  {
    path: 'general',
    children: [...countryRoutes, ...currencyRoutes, ...budgetGoalsRoutes],
  },
];
